<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="assign-controls">
    <!-- State Group Display -->
    <div class="control-row">
      <div class="control-label">State Group</div>
      <div class="control-input">
        <input type="text" readonly [ngModel]="stateGroupDisplayName" class="form-control input-sm subtableRowHeight">
      </div>
    </div>

    <!-- Entity Type Selection -->
    <div class="control-row">
      <div class="control-label">Entities</div>
      <div class="control-input">
        <label style="margin-right: 20px;">
          <input type="radio" [(ngModel)]="entityType" (ngModelChange)="onEntityTypeChange()" value="INTERNAL"> Internal
        </label>
        <label>
          <input type="radio" [(ngModel)]="entityType" (ngModelChange)="onEntityTypeChange()" value="EXTERNAL"> State Entity
        </label>
      </div>
    </div>

    <!-- Select Entities -->
    <div class="control-row">
      <div class="control-label">
        @if (isExternalEntityLoading || isInternalEntityLoading) {
<span>
          <i class="fa fa-spinner fa-pulse"></i>
        </span>
}
        Select Entities
      </div>
      <div class="control-input">
        <!-- External Entities Dropdown Multi-Select -->
        @if (entityType === 'EXTERNAL' && allExternalEntities.length > 0) {
<div 
             class="custom-multiselect" 
             [class.open]="externalDropdownOpen">
          <button type="button" 
                  class="mul-select-btn"
                  (click)="toggleExternalDropdown($event)">
            <span class="selected-text">
              {{ selectedExternalEntities.length > 0 ? selectedExternalEntities.length + ' of ' + allExternalEntities.length + ' selected' : 'Select Entities' }}
            </span>
            <span class="caret"></span>
          </button>
          @if (externalDropdownOpen) {
<div class="dropdown-menu" 
              
               (click)="$event.stopPropagation()">
            <div class="dropdown-header">
              <button type="button" 
                      class="dropdown-action-btn"
                      (click)="selectAllExternalEntities(); $event.stopPropagation()">
                Select all
              </button>
              <button type="button" 
                      class="dropdown-action-btn"
                      (click)="clearAllExternalEntities(); $event.stopPropagation()">
                Unselect all
              </button>
            </div>
            <div class="dropdown-items">
              @for (entity of allExternalEntities; track $index) {
<label 
                     class="dropdown-item"
                     (click)="$event.stopPropagation()">
                <input type="checkbox"
                       [checked]="isEntitySelected(entity, 'EXTERNAL')"
                       (change)="toggleEntitySelection(entity, 'EXTERNAL')">
                <span>{{entity.LABEL}}</span>
              </label>
}
            </div>
          </div>
}
        </div>
}

        <!-- Internal Entities Dropdown Multi-Select -->
        @if (entityType === 'INTERNAL' && allInternalEntities.length > 0) {
<div 
             class="custom-multiselect" 
             [class.open]="internalDropdownOpen">
          <button type="button" 
                  class="mul-select-btn"
                  (click)="toggleInternalDropdown($event)">
            <span class="selected-text">
              {{ selectedInternalEntities.length > 0 ? selectedInternalEntities.length + ' of ' + allInternalEntities.length + ' selected' : 'Select Entities' }}
            </span>
            <span class="caret"></span>
          </button>
          @if (internalDropdownOpen) {
<div class="dropdown-menu" 
              
               (click)="$event.stopPropagation()">
            <div class="dropdown-header">
              <button type="button" 
                      class="dropdown-action-btn"
                      (click)="selectAllInternalEntities(); $event.stopPropagation()">
                Select all
              </button>
              <button type="button" 
                      class="dropdown-action-btn"
                      (click)="clearAllInternalEntities(); $event.stopPropagation()">
                Unselect all
              </button>
            </div>
            <div class="dropdown-items">
              @for (entity of allInternalEntities; track $index) {
<label 
                     class="dropdown-item"
                     (click)="$event.stopPropagation()">
                <input type="checkbox"
                       [checked]="isEntitySelected(entity, 'INTERNAL')"
                       (change)="toggleEntitySelection(entity, 'INTERNAL')">
                <span>{{entity.LABEL}}</span>
              </label>
}
            </div>
          </div>
}
        </div>
}

        <!-- No Entities Message -->
        @if ((entityType === 'EXTERNAL' && allExternalEntities.length === 0 && !isExternalEntityLoading) ||
                    (entityType === 'INTERNAL' && allInternalEntities.length === 0 && !isInternalEntityLoading)) {
<div 
             class="no-entities-message">
          No entities available
        </div>
}
      </div>
      <div class="control-button">
        <button class="add-entity-button" type="button" (click)="onAssignEntity()">
          Add Entities
        </button>
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
      </div>
    </div>
  </div>

  <!-- Assigned Entities Table -->
  <div class="assigned-entities-container">
    @if (allAssignedEntities.length > 0) {
<div class="table-container">
      <!-- Search Filter -->
      <div class="table-header">
        <div class="search-box">
          <input type="text"
                 [(ngModel)]="globalFilterValue"
                 (input)="onGlobalFilter($event)"
                 placeholder="Search all columns..."
                 class="search-input">
          <i class="fa fa-search search-icon"></i>
        </div>
      </div>

      <div class="assigned-entities-table-scroll">
        <table mat-table [dataSource]="assignedEntitiesDataSource" matSort class="assigned-entities-mat-table">
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="col-delete">Delete</th>
            <td mat-cell *matCellDef="let entity" (click)="onUnassignEntity(entity)" class="delete-entity-cell col-delete">
              <span class="delete-entity"><i class="fa fa-trash color-red"></i></span>
            </td>
          </ng-container>
          <ng-container matColumnDef="LEID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-leid">LEID - Tax Code - Reporting Period</th>
            <td mat-cell *matCellDef="let entity" class="col-leid">
              {{entity.LEID || ''}}{{entity.HO_CDR_NO ? '-' + entity.HO_CDR_NO : ''}}{{entity.HO_REPORTING_PERIOD ? '-' + entity.HO_REPORTING_PERIOD : ''}}
            </td>
          </ng-container>
          <ng-container matColumnDef="LE_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-le-name">LE Name</th>
            <td mat-cell *matCellDef="let entity" class="col-le-name">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<input type="text" [(ngModel)]="entity.LE_NAME" class="form-control input-sm table-input">
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{entity.LE_NAME || ''}}</span>
}
            </td>
          </ng-container>
          <ng-container matColumnDef="ENTITY_TYPE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-entity-type">Entity Type</th>
            <td mat-cell *matCellDef="let entity" class="col-entity-type">{{entity.ENTITY_TYPE || ''}}</td>
          </ng-container>
          <ng-container matColumnDef="EIN">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-ein">EIN</th>
            <td mat-cell *matCellDef="let entity" class="col-ein">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<input type="text" [(ngModel)]="entity.EIN" class="form-control input-sm table-input" maxlength="10">
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{entity.EIN}}</span>
}
            </td>
          </ng-container>
          <ng-container matColumnDef="consolidated">
            <th mat-header-cell *matHeaderCellDef class="col-consolidated">Consolidated?</th>
            <td mat-cell *matCellDef="let entity" class="col-consolidated">
              {{entity.LE_CONSOL_TYPE_FLAG === 'C' ? 'Yes' : 'No'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESS_LINE1">
            <th mat-header-cell *matHeaderCellDef class="col-address1">Address Line 1</th>
            <td mat-cell *matCellDef="let entity" class="col-address1">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<input type="text" [(ngModel)]="entity.ADDRESS_LINE1" class="form-control input-sm table-input">
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{entity.ADDRESS_LINE1}}</span>
}
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESS_LINE2">
            <th mat-header-cell *matHeaderCellDef class="col-address2">Address Line 2</th>
            <td mat-cell *matCellDef="let entity" class="col-address2">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<input type="text" [(ngModel)]="entity.ADDRESS_LINE2" class="form-control input-sm table-input">
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{entity.ADDRESS_LINE2}}</span>
}
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESS_CITY">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-city">City</th>
            <td mat-cell *matCellDef="let entity" class="col-city">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<input type="text" [(ngModel)]="entity.ADDRESS_CITY" class="form-control input-sm table-input">
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{entity.ADDRESS_CITY}}</span>
}
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESS_STATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-state">State</th>
            <td mat-cell *matCellDef="let entity" class="col-state">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<select class="form-control input-sm table-select" [(ngModel)]="entity.ADDRESS_STATE">
                <option value="">Select State</option>
                @for (state of allUSStates; track $index) {
<option [value]="state.STATE_CODE">{{state.STATE_DESC}}</option>
}
              </select>
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{getStateName(entity.ADDRESS_STATE)}}</span>
}
            </td>
          </ng-container>
          <ng-container matColumnDef="ADDRESS_ZIP">
            <th mat-header-cell *matHeaderCellDef class="col-zip">Zip</th>
            <td mat-cell *matCellDef="let entity" class="col-zip">
              @if (entity.EXTERNAL_Y_N !== 'N') {
<input type="text" [(ngModel)]="entity.ADDRESS_ZIP" class="form-control input-sm table-input">
}
              @if (entity.EXTERNAL_Y_N === 'N') {
<span>{{entity.ADDRESS_ZIP}}</span>
}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="assignedDisplayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: assignedDisplayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="assignedDisplayedColumns.length" style="text-align: center; padding: 20px;">
              No assigned entities found
            </td>
          </tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveLoading" 
          (click)="onSaveAddress()">
    Save Address
    @if (isSaveLoading) {
<span>
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
}
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
